(function () {
  'use strict';

  angular.module('ringbaPortal').component('settingOverrideView', {
    bindings: {
      override: '<'
    },
    controller: SettingOverrideView,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/setting-override-view.view.html'
  });

  function SettingOverrideView() {
    'ngInject';

    const vm = this;
    vm.$onChanges = onChanges;

    function onChanges(changesObj) {
      if (changesObj && changesObj.override && changesObj.override.currentValue) {
        _setResult(changesObj.override.currentValue);
      }
    }

    function _setResult(or) {
      vm.off = !or || (!or.campaignOverride && !or.globalOverride);
      vm.campaign = !vm.off && or.campaignOverride;
      vm.global = !vm.off && or.globalOverride;
    }
  }
})();
